import { flex } from 'hfty-styles/src/mixins'

const HEADER_HEIGHT = '50px'

export const styles = {
  header: {
    ...flex('space-between'),
    width: '100%',
    height: HEADER_HEIGHT,
    marginBottom: '45px',
    borderBottom: `1px solid rgb(197, 197, 197)`,
  },
  headerPhone: {
    color: 'rgb(121, 121, 121)',
  },
  headerTitle: {
    fontSize: '24px',
  },
}
